/**
 * The programmes a student record can be in, as this app's pickers offer them.
 *
 * The words and the labels are `@gradebook/shared`'s — one vocabulary for the
 * schema, the API and the UI, so a filter cannot offer a programme the form
 * cannot create or spell one of them differently. What stays here is only the
 * `<Select>` shape, which is a frontend concern.
 */
import {
  PROGRAM_LABELS,
  STUDENT_PROGRAMS,
  isStudentProgram,
  type StudentProgram,
} from '@gradebook/shared'

export {
  STUDENT_PROGRAMS,
  isStudentProgram,
  type StudentProgram,
}

/** The same choices as `<Select>` options, in the order the form lists them. */
export const studentProgramOptions = STUDENT_PROGRAMS.map((value) => ({
  value,
  label: PROGRAM_LABELS[value],
}))
